
<form class="form-inline form-datepicker">
  <div class="form-group" style="width: 100%;">
    <input [ngStyle]="inputStyle"
    [fedMask]="maskConfig"
    tabindex="{{tabindex}}" class="form-control"
    [formControl]="formControl"
    [disabled]="isDisabled"
    [ngClass]="{ 'input-required': validators }"
    [minDate]="minDate"
    [maxDate]="maxDate"
    name="dp"
    ngbDatepicker
    #d="ngbDatepicker"
    placeholder="{{placeHolder}}"
    (click)="markAsTouched()"
    />
    <div class="input-group-append" style="height: 39px;">
      <button class="btn btn-outline-secondary calendar" (click)="d.toggle()" type="button"
        style="height: 100%;" [disabled]="isDisabled">
      </button>
    </div>
  </div>
</form>
